import React, { Component } from 'react';
import { Table, Row, Col } from 'react-bootstrap/lib'
import { Image } from 'react-bootstrap/lib'
import { Link } from 'react-router-dom'
import logoSvg from '../../../images/cr-logo-new.png'
import Api from './Api';

class BedrijvenSearchResultTable extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleSortingClick = this.handleSortingClick.bind(this);
    }

    handleClick() {
        this.props.fnc()
    }

    handleSortingClick(e) {
        this.props.fnc2(e)
    }

    render() {
        let companies = this.props.companies
        return (
            <div className="BedrijvenSearchResultTable table-responsive">
                <Row>
                    <Col md={12}>
                        <div>Resultaten  {this.props.pagination.pageSize} van {this.props.pagination.totalCount}</div>
                        <Table striped bordered hover responsive className="dataTable">
                            <thead>
                                <tr>
                                    <th>Logo</th>
                                    <th className={this.props.parent.Name} onClick={() => this.handleSortingClick("Name")}>Naam</th>
                                    <th className={this.props.parent.PostCode} onClick={() => this.handleSortingClick("PostCode")}>Postcode</th>
                                    <th className={this.props.parent.City} onClick={() => this.handleSortingClick("City")}>Plaats</th>
                                    <th>Telefoon</th>
                                    <th>Website</th>
                                </tr>
                            </thead>
                            <tbody>
                                {companies !== undefined ? companies.map((item, index) => {
                                    return <tr key={index} style={{ height: "37px" }}>
                                        <td className="text-center" style={{ padding: "2px", height: "37px" }}>
                                            {item.logo === "" ? "" : <img src={Api.Url + item.logo} alt={"Logo van " + item.name} className="img-responsive" style={{ display: "initial", maxHeight: "30px" }} />}
                                        </td>
                                        <td>{item.name}</td>
                                        <td>{item.postcode}</td>
                                        <td>{item.city}</td>
                                        <td>{item.phone}</td>
                                        <td>{item.website === "" ? "" : <a href={"http://" + item.website} target="_blank" title={"Bekijk website van " + item.name}>website</a>}</td>
                                    </tr>
                                }) : null}
                            </tbody>
                        </Table>
                        <div className="paginationStyling">
                            <div style={{ float: 'left' }}>
                                {this.props.pagination.prevButton}
                            </div>
                            <div style={{ float: 'center' }}>
                                Pagina {this.props.pagination.currentPage} van {this.props.pagination.totalPages}
                            </div>
                            <div style={{ float: 'right' }}>
                                {this.props.pagination.nextButton}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default BedrijvenSearchResultTable;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/BedrijvenSearchResultTable.js